/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiBookingListQuickFilter = typeof GetApiBookingListQuickFilter[keyof typeof GetApiBookingListQuickFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiBookingListQuickFilter = {
  active_upcoming: 'active_upcoming',
  past: 'past',
  others: 'others',
  all: 'all',
} as const;
